import type {
  MarketplaceBrowseMapMarkerFragment,
  MarketplaceGeoPointInput,
} from '../browse/__generated__/marketplace-browse.zeus';
import type { MarketplaceZoneType } from './__generated__/location-search.zeus';

export type MapMarkerProperty = Omit<MarketplaceBrowseMapMarkerFragment, 'location'> & {
  isLiked: boolean;
  latitude: number;
  longitude: number;
};

export type MapLocation = {
  label: string;
  zoneType: MarketplaceZoneType;
  value: string;
  coordinates?: [number, number];
};

export type GeoPoint = MarketplaceGeoPointInput;

export interface MarketShape {
  coordinates: GeoPoint[][];
  type: 'Polygon';
}

export interface MarketInfo {
  shape: MarketShape;
  displayName: string;
  name: string;
  identifier: string | null;
}

// Fixed heights for the map mini PDP carousel on mobile web. Pinning height
// prevents CLS while photos load; the square aspect ratio is overridden below
// the `md` breakpoint where the mobile mini PDP is shown.
export const MOBILE_CAROUSEL_HEIGHT_BASE = 260;
export const MOBILE_CAROUSEL_HEIGHT_SM = 414;

/** Static Tailwind classes — pixel values must stay in sync with MOBILE_CAROUSEL_HEIGHT_* above. */
export const MAP_MINI_PDP_CAROUSEL_LAYOUT_CLASS =
  'aspect-square w-full shrink-0 h-[260px] sm:h-[414px] md:h-auto md:aspect-video';

/** Mobile mini PDP sheet height — used for layout, closed-state slide, and dismiss animation. */
export const MOBILE_MINI_PDP_PANEL_HEIGHT = '75vh';

export const MOBILE_MINI_PDP_PANEL_HEIGHT_CLASS = 'h-[75vh]';

export const MOBILE_MINI_PDP_PANEL_CLOSED_TRANSLATE_CLASS = 'translate-y-[75vh]';
